import { useMutation } from "@tanstack/react-query";

import { createWaterClass } from "@services/waterClass";

export const useCreateWaterClass = (options: Record<string, any> = {}) => {
  return useMutation(createWaterClass, {
    ...options,
  });
};
